<div class="row">
  <div class="col-sm-8">
    <h2>{{ 'DEV_CLIENTS.TITLE' | translate }}</h2>
    <p class="text-muted">{{ 'DEV_CLIENTS.SUBTITLE' | translate }}</p>
  </div>
  <div class="col-sm-4">
    <button type="button" class="btn btn-primary px-4" style="float: right" (click)="openCreateDialog()">
      {{ 'DEV_CLIENTS.NEW_CLIENT' | translate }}
    </button>
  </div>
</div>

<div class="col-12" style="margin-top: 20px">
  <nb-card>
    <nb-card-body>
      <table class="table text-center">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{ 'DEV_CLIENTS.TABLE.NAME' | translate }}</th>
            <th scope="col">{{ 'DEV_CLIENTS.TABLE.ACCESS' | translate }}</th>
            <th scope="col">{{ 'DEV_CLIENTS.TABLE.SCOPES' | translate }}</th>
            <th scope="col">{{ 'DEV_CLIENTS.TABLE.STATUS' | translate }}</th>
            <th scope="col">{{ 'DEV_CLIENTS.TABLE.LAST_USED' | translate }}</th>
            <th scope="col">{{ 'DEV_CLIENTS.TABLE.CREATED' | translate }}</th>
            <th scope="col">{{ 'DEV_CLIENTS.TABLE.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let client of clients
                | paginate: { itemsPerPage: count, currentPage: page, totalItems: total };
              let i = index
            "
          >
            <td>{{ (page - 1) * count + i + 1 }}</td>
            <td class="text-start">
              <strong>{{ client.name }}</strong>
              <br />
              <small class="text-muted client-id">{{ client.clientId }}</small>
            </td>
            <td class="text-start">{{ accessLabel(client) }}</td>
            <td class="text-start">
              <span *ngFor="let scope of formatScopes(client.scopes)" class="scope-chip" [title]="scope">
                {{ scopeLabelKey(scope) | translate }}
              </span>
            </td>
            <td>
              <nb-badge
                [text]="(client.isActive ? 'DEV_CLIENTS.STATUS.ACTIVE' : 'DEV_CLIENTS.STATUS.REVOKED') | translate"
                [status]="client.isActive ? 'success' : 'danger'"
              ></nb-badge>
            </td>
            <td>{{ formatLastUsed(client.lastUsed) }}</td>
            <td>{{ formatCreated(client.createdAt) }}</td>
            <td>
              <nb-icon
                style="cursor: pointer"
                (click)="openEditDialog(client)"
                class="right"
                icon="edit-outline"
                [nbTooltip]="'DEV_CLIENTS.ACTIONS.EDIT' | translate"
              ></nb-icon>
              <nb-icon
                style="cursor: pointer"
                (click)="rotateSecret(client)"
                class="right"
                icon="refresh-outline"
                [nbTooltip]="'DEV_CLIENTS.ACTIONS.ROTATE' | translate"
              ></nb-icon>
              <nb-icon
                *ngIf="client.isActive"
                style="cursor: pointer"
                (click)="revokeClient(client)"
                class="right deleteIcon"
                icon="slash-outline"
                [nbTooltip]="'DEV_CLIENTS.ACTIONS.REVOKE' | translate"
              ></nb-icon>
              <nb-icon
                *ngIf="!client.isActive"
                style="cursor: pointer"
                (click)="activateClient(client)"
                class="right activateIcon"
                icon="checkmark-circle-outline"
                [nbTooltip]="'DEV_CLIENTS.ACTIONS.ACTIVATE' | translate"
              ></nb-icon>
            </td>
          </tr>
          <tr *ngIf="clients.length === 0">
            <td colspan="8" class="text-center" style="padding: 30px; color: #888">
              {{ 'DEV_CLIENTS.EMPTY' | translate }}
            </td>
          </tr>
        </tbody>
      </table>
      <pagination-controls
        class="pagination"
        [responsive]="true"
        (pageChange)="pageChanged($event)"
        [previousLabel]="'DEV_CLIENTS.PAGINATION.PREV' | translate"
        [nextLabel]="'DEV_CLIENTS.PAGINATION.NEXT' | translate"
        [screenReaderPaginationLabel]="'DEV_CLIENTS.PAGINATION.ARIA' | translate"
        [screenReaderPageLabel]="'DEV_CLIENTS.PAGINATION.PAGE' | translate"
        [screenReaderCurrentLabel]="'DEV_CLIENTS.PAGINATION.CURRENT_PAGE' | translate"
      ></pagination-controls>
    </nb-card-body>
  </nb-card>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">{{ 'DEV_CLIENTS.LOADING' | translate }}</p>
</ngx-spinner>
